<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm10 md8>
        <v-form @submit="submit" v-model="valid" lazy-validation ref="form">
          <v-card class="elevation-12">
            <v-card dark height="200px">
              <v-container fill-height fluid>
                <v-layout fill-height align-center>
                  <v-flex xs-12 flexbox>
                    <span class="headline white--text">{{$t('login')}}</span>
                  </v-flex>
                </v-layout>
                <v-layout fill-height align-top text-xs-right>
                  <v-flex xs-12 flexbox>
                    <span class="white--text">{{currentGateway.id}}</span>
                    
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
            <v-card-text>
              <ul v-if="errors" class="error-messages">
                <li v-for="(v, k) in errors" :key="k">{{ k }} {{ v }}</li>
              </ul>
              <v-text-field
                autofocus
                prepend-icon="person"
                name="username"
                label="Username"
                v-model="username"
                :rules="emailRules"
                required
              ></v-text-field>
              <v-text-field
                prepend-icon="lock"
                name="password"
                label="Password"
                id="password"
                type="password"
                required
                v-model="password"
                :rules="passwordRules"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" type="submit">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoginPage",
  data() {
    return {
      valid: false,
      username: "",
      password: "",
      emailRules: [v => !!v || "Username is required"],
      passwordRules: [v => !!v || "Password is required"]
    };
  },
  methods: {
    submit(event) {
      event.preventDefault();
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("auth/login", {
            username: this.username,
            password: this.password
          })
          .then(() => this.$router.push({ name: "home" }));
      }
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
      currentGateway: state => state.gateways.current
    })
  }
};
</script>

<style scoped>
</style>